module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The incapacity of Harun to restrain the followers of the Calf . . . was a wisdom from God made manifest in existence: that He be worshipped in every form.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Muhyi al-Din Ibn ʿArabi")]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Democracy has no monuments. . . . Its very essence is iconoclastic.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("John Quincy Adams")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e281af32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-tugendhaft-0006.vue
// module id = 69
// module chunks = 0